import React from 'react';

class Navigation extends React.Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {

    const selected = event.target.value;

    if (this.props.onChange) {
      this.props.onChange({ direction: selected });
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        <button
          type="button"
          name="step"
          value="-1"
          onClick={this.handleChange}>Previous</button>
        <button
          type="button"
          name="step"
          value="1"
          onClick={this.handleChange}>Next</button>
      </div>
    );
  }
}

Navigation.defaultProps = {
  className: "nav-bar"
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/calendar/Navigation.js